<template>
  <div class="flex flex-col">
    <div class="flex flex-col justify-between mb-4">
      <div class="font-bold">
        <slot name="title">Условия определения права на ЛМСЗ</slot>
      </div>
      <BaseError v-if="hasError('base_conditions')">
        {{ getError('base_conditions') }}
      </BaseError>
    </div>

    <div class="flex flex-col bg-cultured rounded overflow-hidden relative">
      <div class="py-4 px-4">
        <div
          class="ml-8 mr-4 mt-4 bg-white condition-container overflow-y-auto scrollbar-w-2 scrollbar-track-gray-lighter scrollbar-thumb-rounded scrollbar-thumb-gray"
        >
          <div
            class="flex flex-row items-center justify-between border-b last:border-b-0 px-5 py-2 border-gainsboro"
          >
            <div class="font-bold text-sm ml-10">
              Укажите условия определения права на меру
            </div>
            <div>
              <BaseButton
                size="none"
                variant="none"
                @click="toggleShowAllConditions"
              >
                <BaseIcon
                  :name="showedAll ? 'ok' : 'edit-note'"
                  width="20"
                  height="20"
                />
              </BaseButton>
            </div>
          </div>
          <template v-for="(condition, condIndex) in conditions">
            <div
              v-if="showedAll || getValue(condition.id) !== null"
              :key="`condition-${condIndex}`"
              class="flex flex-row items-center justify-between px-5 py-2 border-b last:border-b-0 border-gainsboro"
            >
              <div class="flex flex-row">
                <div class="font-light text-sm w-10 min-w-10">
                  {{ condition.id }}
                </div>

                <div class="font-light text-sm mr-4">
                  {{ condition.name }}
                </div>
              </div>
              <div class="flex flex-row">
                <BaseCheckbox
                  class="mr-4 last:mr-0"
                  label="Да"
                  :disabled="disabled"
                  :value="checkboxValue(condition.id, true)"
                  @input="onInput(condition.id, true)"
                />
                <BaseCheckbox
                  class="mr-4 last:mr-0"
                  label="Нет"
                  :disabled="disabled"
                  :value="checkboxValue(condition.id, false)"
                  @input="onInput(condition.id, false)"
                />
              </div>
            </div>
          </template>
          <div
            v-if="!conditions.length"
            class="flex flex-row justify-center my-4 text-sm"
          >
            Выберите жизненную ситуацию
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import cloneDeep from 'lodash/cloneDeep';

  import BaseIcon from '@/components/global/base-icon';
  import BaseError from '@/components/global/base-error';
  import BaseButton from '@/components/global/base-button';
  import BaseCheckbox from '@/components/global/base-checkbox';

  export default {
    name: 'CategoryCondition',

    components: {
      BaseIcon,
      BaseError,
      BaseButton,
      BaseCheckbox,
    },

    props: {
      value: {
        type: Array,
        default: () => [],
      },
      errors: {
        type: Object,
        default: () => {},
      },
      conditions: {
        type: Array,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        showAll: true,
      };
    },

    computed: {
      showedAll() {
        return this.showAll;
      },
    },

    methods: {
      hasError(key) {
        return typeof this.errors[key] !== 'undefined';
      },

      getError(key) {
        return this.errors[key].join('. ');
      },

      toggleShowAllConditions() {
        this.showAll = !this.showAll;
      },

      getValue(conditionId) {
        let conditionItem = this.value.find((item) => item.id === conditionId);

        let checkedValue = null;
        if (conditionItem) {
          checkedValue = conditionItem.value;
        }

        return checkedValue;
      },

      checkboxValue(conditionId, val) {
        return this.getValue(conditionId) === val;
      },

      onInput(conditionId, val) {
        let items = cloneDeep(this.value);
        let conditionItem = items.find((item) => item.id === conditionId);

        if (typeof conditionItem === 'undefined') {
          items.push({
            id: conditionId,
            value: val,
          });
        } else if (conditionItem.value !== val) {
          conditionItem.value = val;
        } else {
          items = items.filter((item) => item.id !== conditionId);
        }

        this.$emit('input', items);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .condition-container {
    max-height: rem(500px);
  }
  .scrollbar-w-2::-webkit-scrollbar {
    width: 0.5rem !important;
    height: 0.5rem !important;
  }
  .scrollbar-thumb-rounded::-webkit-scrollbar-thumb {
    border-radius: 0.25rem !important;
  }
  .scrollbar-thumb-gray::-webkit-scrollbar-thumb {
    --bg-opacity: 1 !important;
    background-color: #cbd5e0 !important;
    background-color: rgba(203, 213, 224, var(--bg-opacity)) !important;
  }
  .scrollbar-track-gray-lighter::-webkit-scrollbar-track {
    --bg-opacity: 1 !important;
    background-color: #e2e8f0 !important;
    background-color: rgba(226, 232, 240, var(--bg-opacity)) !important;
  }
</style>
